<template>
    <div class="inspection-wrapper">

    <div class="devicemanage_class">
        <div class="rt-container" style="margin-bottom: 10px" ref="tableSelect2">
        <div class="div_11 ">
            <div class="dev_11_backgroud_1"></div>
            <div class="space-main">
                <div class="space-main-up">
                    <span style="font-size: 24px;color: #e9c32a;">{{ deviceInfo.total }}</span>
                    <span style="font-size: 18px;">&nbsp;台</span>
                </div>
                <div class="space-header">
                    <div class="space-header-title">设备总数</div>
                </div>
            </div>

        </div>
        <div class="div_22 dev_11_backgroud_1_1"></div>
        <div class="div_11">
            <div class="dev_11_backgroud_2"></div>
            <div class="space-main">
                <div class="space-main-up">
                    <span style="font-size: 24px;color: #e9c32a;">{{deviceInfo.health}}</span>
                    <span style="font-size: 18px;">&nbsp;台</span>
                </div>
                <div class="space-header">
                    <div class="space-header-title">正常运行设备数</div>
                </div>
            </div>
        </div>

        <div class="div_22 dev_11_backgroud_1_1"></div>
        <div class="div_11">
            <div class="dev_11_backgroud_3"></div>
            <div class="space-main">
                <div class="space-main-up">
                    <span style="font-size: 24px;color: #e9c32a;">{{ deviceInfo.fault }}</span>
                    <span style="font-size: 18px;">&nbsp;台</span>
                </div>
                <div class="space-header">
                    <div class="space-header-title">报警设备数</div>
                </div>
            </div>
        </div>

        <div class="div_22 dev_11_backgroud_1_1"></div>

        <div class="div_11 ">
            <div class="dev_11_backgroud_4"></div>
            <div class="space-main">
                <div class="space-main-up">
                    <span style="font-size: 24px;color: #e9c32a;">{{ deviceInfo.stopped }}</span>
                    <span style="font-size: 18px;">&nbsp;台</span>


                </div>
                <div class="space-header">
                    <div class="space-header-title">停机设备数</div>
                </div>
            </div>
        </div>
        <!-- <div class="div_22 dev_11_backgroud_1_1"></div>
        <div class="div_11 div_111">
            <div class="center-container_dev">
                <el-button @click="addDevicefun" icon="Plus" class="custom-button_dev">新增设备</el-button>
            </div>
        </div> -->

    </div>
    </div>
 
    <div class="devicemanage_class_1">
        
        <div class="seachtitle ">
            <el-form :inline="true" :model="formInline" label-position="left" class="tableform">
                <!-- <el-form-item label="设备类型：">
                    <el-select v-model="formInline.deviceType" placeholder="请选择" size="default" clearable
                        style="width:160px">
                        <el-option v-for="item in deviceTypeList" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item> -->
                <el-form-item label="设备名称：">
                    <el-input size="default" v-model.trim="formInline.deviceName"  placeholder="请输入设备名称"
                        clearable style="min-width:120px"></el-input>
                </el-form-item>
                <el-form-item label="开始时间：">
                    <el-date-picker  
                            style="min-width:160px"  
                            v-model="startDate"   
                            type="date"  
                            @change="startTimeChange"  
                    ></el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间：">  
                    <el-date-picker  
                            style="min-width:160px"  
                            v-model="endDate"  
                            type="date"  
                            @change="endTimeChange"  
                    ></el-date-picker>  
                </el-form-item>
                <el-form-item label="分厂：">
                    <el-select v-model="formInline.branch_factory" placeholder="请选择" size="default" clearable
                        style="width:160px;">
                        <el-option v-for="item in factoryGroupList" :key="item.id" :label="item.name" :value="item.name">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="工段：">
                    <el-input size="default" v-model.trim="formInline.workshop_section" maxlength="30" placeholder="请输入工段名称"
                    clearable style="width:160px"></el-input>
                </el-form-item>
                <el-form-item label="账号：">
                    <el-input size="default" v-model.trim="formInline.user" maxlength="30" placeholder="请输入账号"
                    clearable style="width:160px"></el-input>
                </el-form-item>
            
                <el-form-item>
                    <el-button @click="search" type="primary" icon="Search" style="margin-left: 10px;">查询</el-button>
                    <el-button @click="handleEdit('','reset')" icon="Refresh" style="margin-left: 20px;">重置</el-button>
                    <el-button @click="exportTable" type="primary" style="margin-left:120px;">导出</el-button>
                </el-form-item>
               

            </el-form>
        </div>
        <div class="ops_content">
            <el-table  border id="checkrecordtable" :data="tableData" ref="tableref"
                v-loading="loadingPage" style="width: 100%;">
                <el-table-column type="index" width="60" align="center" label="序号">
                    <template #default="scope">
                        <span v-text="getIndex(scope.$index)"></span>
                    </template>
                </el-table-column>
                <el-table-column min-width="100" prop="device_name" label="设备名称" show-overflow-tooltip
                    align="center"></el-table-column>
                <!-- <el-table-column min-width="100" prop="transform_device_type" label="设备类型" show-overflow-tooltip
                    align="center">重点设备</el-table-column> -->
                <el-table-column min-width="60" prop="branch_factory" label="分厂" show-overflow-tooltip
                    align="center"></el-table-column>
                <el-table-column min-width="60" prop="workshop_section" label="工段" show-overflow-tooltip
                align="center"></el-table-column>
                <el-table-column min-width="60" prop="user" label="账号" show-overflow-tooltip
                align="center"></el-table-column>
                <el-table-column min-width="100" prop="sensor_name" label="测点名称" show-overflow-tooltip
                    align="center"></el-table-column>
                <!-- <el-table-column min-width="60" prop="sensor_status" label="设备位号" show-overflow-tooltip
                    align="center"></el-table-column> -->
                <el-table-column min-width="60" prop="sensor_sn" label="NFC信息" show-overflow-tooltip
                align="center"></el-table-column>
                <el-table-column min-width="60" prop="intensity" label="烈度(mm/s)" show-overflow-tooltip
                align="center"></el-table-column>
                <el-table-column min-width="40" prop="temperature" label="温度(°C)" show-overflow-tooltip
                align="center"></el-table-column>
                <el-table-column min-width="80" prop="time" label="巡检时间" show-overflow-tooltip
                    align="center"></el-table-column>
              
                <el-table-column label="操作" fixed="right" min-width="100" align="center">
                    <template #default="{row}">
                        <!-- <el-button  type="primary" @click="handledetail(row,'xunjian')" >查看</el-button> -->
                        <el-button  type="danger"  @click="handleEdit(row.id,'delete')" >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather" ></Pagination>

    </div>
   
   
    <inspectionDetail ref="faultInfoFlag" @handleInfo="handleInfo" ></inspectionDetail>
  </div>
 
  
 
</template>


<script>
import {apiInspectionCenter,apiSensorDelete1,apiDeviceNumberStatistics1} from '@/api/api'
import Pagination from "@/components/Pagination";
import inspectionDetail from "./components/inspectiondetail.vue";
import deviceTypeConfig from "@/config"

import * as XLSX from 'xlsx';

import addDevice from "./components/addDevice";

import {timestampToTime} from '@/utils/util'
 export default{
    name:'inspectionCenter',
    emits: ['handleInfo'],
    components:{
            Pagination,
            addDevice,
          
            inspectionDetail,
          
        },
    data(){
        return{
         
            treeHighLightFlag:true,
            tableHeight:500,
          
            loadingPage:false,
            showOtherSearch:false,//隐藏过长的搜索条件

            deviceInfo:{
                    total:0,
                    health:0,
                    online:0,
                    offline:0,
                    stopped:0,
                    fault:0,
                },
            formInline:{
                    group_type: null,
                    deviceName: null,
                    time:null,
                    branch_factory:null,
                    workshop_section: null,
                    user:null,
            },
            tableData:[],
          
            deviceTypeList:[
                    {id:0,name:'全部'},
                    
            ],
            factoryGroupList:[
                    {id:0,name:'全部'},
                    {id:1,name:deviceTypeConfig.DEVICE_TYPE_1},
                    {id:2,name:deviceTypeConfig.DEVICE_TYPE_2},
                    {id:3,name:deviceTypeConfig.DEVICE_TYPE_3},
                    {id:4,name:deviceTypeConfig.DEVICE_TYPE_4},
                    {id:5,name:deviceTypeConfig.DEVICE_TYPE_5},
                    {id:6,name:deviceTypeConfig.DEVICE_TYPE_6},
            ],  
          
            pageparm: {
                    page: 1,
                    page_size: 10,
                    total:1
                },
            fnParm:{
                page: 1,
                page_size: 10,  
            
                ordering:"processed,-time",         
            },
            fntableParm:{
                    page: 1,
                    page_size: 10,
                   
                    device_type : null,
                   
                    branch_factory_exact: null,
                    device_name : null,
                    time_after: null,   
                    time_before: null,
                    workshop_section_exact : null, 
                    user:null,    
                    ordering:"processed,-time",   
                },
            startDate:[],
            endDate:[],
    }
    },
    methods:{
          // 表格序列号
            getIndex($index) {
                // (当前页 - 1) * 当前显示数据条数 + 当前行数据的索引 + 1
                return (this.pageparm.page-1)*this.pageparm.page_size + $index +1
            },
       
            handleEdit(id,flag) {
              
            
                if(flag=='delete') {
                    this.$confirm('您确定要删除选中的数据吗？' ,{
                        closeOnClickModal:false
                    }).then(res=>{
                        //现在的DELETE命令，通过代理不能收到响应！？                       
                        apiSensorDelete1({id}).then(res=>{
                            this.$message.success("删除传感器成功")
                            this.getData()
                        }) .catch(res => {  
                          
                            this.$message.warning(`删除传感器失败 : ${res.message}`)
                        });

                    }).catch(()=>{

                    })
                }
                else if(flag=="reset"){
                  
                    
                    this.fntableParm = {
                        page:1,
                        page_size: 10,
                        ordering: "-device__status,device__name",
                    }
                    this.pageparm={
                        page: 1,
                        page_size: 10,
                        total: 0
                    }
                    this.startDate = ''
                    this.endDate = ''
                    this.treeHighLightFlag = false
                    this.formInline.deviceName = null
                    this.formInline.workshop_section = null
                    this.formInline.group_type = null
                    this.formInline.branch_factory = null
                    this.formInline.user = null
                    this.getData()
                }
            },
            callFather(parm) {
              
                this.fntableParm.page = parm.page
                this.fntableParm.page_size = parm.page_size
                // this.fnParm.page = parm.page
                // this.fnParm.page_size = parm.page_size
                this.fntableParm.ordering = "processed,-time",
                this.getData()
            },
          
           
            handledetail(row,val){
                let title = "故障告警/告警详情：" + row.device_name
                this.$refs.faultInfoFlag.faultInfoFn(row,title,val)
            },
            
           
            handleInfo(flag){
               
                
               if(flag =='quit'){
            
                this.getData()
               }
              
            },

            search() {
                var dataCount = 0
                if(!(this.startDate == "" || this.startDate == null) ){
                    dataCount += 1
                }
                if(!(this.endDate == "" || this.endDate == null) ){
                    dataCount += 1
                }
                if(dataCount == 1){
                    this.$message.warning("查询时间设置不完整！")
                    return;
                }
               
             
                this.pageparm.page = 1
                this.fntableParm.page = this.pageparm.page
                this.fntableParm.page_size = this.pageparm.page_size
                this.fntableParm.device_name = this.formInline.deviceName
                this.fntableParm.user = this.formInline.user 
                if(this.formInline.branch_factory == null || this.formInline.branch_factory == 0){

                    this.fntableParm.branch_factory_exact = null
                } 
                else{
                
                    this.fntableParm.branch_factory_exact = this.formInline.branch_factory
                } 
                if(this.formInline.deviceType == null || this.formInline.deviceType ==0)
                   {
                    this.fntableParm.device_type = null
                   }
                 
                else{
                    this.fntableParm.device_type = this.formInline.deviceType
                 }
                  
                if(this.formInline.workshop_section == null || this.formInline.workshop_section ==0)
                {
                    this.fntableParm.workshop_section_exact = null
                }
                    
                else{
                    this.fntableParm.workshop_section_exact = this.formInline.workshop_section
                }      
                if(this.formInline.user == null || this.formInline.user ==0)
                {
                    this.fntableParm.user = null
                }
                    
                else{
                    this.fntableParm.user = this.formInline.user
                }                
                    
                this.fntableParm.ordering = "-device__status,device__name"

                this.treeHighLightFlag = false
                this.getData()
            },

            dataChange(items){
                this.tableData.length = 0
                for(let i = 0;i<items.length;i++){
                    this.tableData[i] = items[i]
                    switch(items[i].group_type){
                        case 1:  this.tableData[i].group_type="重点设备" ;break;
                        case 2:  this.tableData[i].group_type="大型机组";break;
                        default: this.tableData[i].group_type="未知" ;break;
                    }
                    switch(items[i].sensor_status){
                        case 0:  this.tableData[i].sensor_status="待定" ;break;
                        case 1:  this.tableData[i].sensor_status="健康" ;break;
                        case 2:  this.tableData[i].sensor_status="故障";break;
                        case 3:  this.tableData[i].sensor_status="停机";break;
                        case 4:  this.tableData[i].sensor_status="离线";break;
                        default: this.tableData[i].sensor_status="未知" ;break;
                    }
                    this.tableData[i].intensity = (items[i].intensity).toFixed(2)
                   
                }       
            },
            getData(){
                this.loadingPage = true
                this.tableData.length = 0;
                apiDeviceNumberStatistics1().then(res => {
                    if(res.data.code ==200) {
                        this.deviceInfo = res.data.data
                    }
                }).catch(error => {  
                    if(error.msg)
                        this.$message.warning(`获取设备状态的数量失败 : ${error.msg}`);  
                    else if(error.message)
                        this.$message.warning(`获取设备状态的数量失败 : ${error.message}`);  
                    else 
                        this.$message.warning(`获取设备状态的数量失败`); 
                });

                console.log('查询条件',this.fntableParm);
                
                apiInspectionCenter(this.fntableParm).then(res => {
                    this.loadingPage = false
                  
                    
                    if(res.data.code ==200) {
                        this.dataChange(res.data.data.items)
                        this.pageparm.total = res.data.data.total;
                        let { page, page_size } = res.config.params 
                        this.pageparm.page = page    
                        this.pageparm.page_size = page_size  
                    }else{
                        this.$message.error(res.data.msg)
                    }
             
                }
           
                
                ) .catch(res => {  
                    this.loadingPage = false
                    this.$message.warning(`获取传感器信息失败 : ${res.msg}`)
                });  
            }, 
            startTimeChange(val){
                if (val) {
                    const start = new Date(val)
                    const startStr = `${start.getFullYear()}-${(start.getMonth() + 1).toString().padStart(2, '0')}-${start.getDate().toString().padStart(2, '0')}`
                    this.fntableParm.time_after = startStr

                    const today = new Date()
                    const todayIntegralPoint = new Date(today.getFullYear(), today.getMonth(), today.getDate());

                    if(start.getTime() > todayIntegralPoint.getTime()){
                        this.startDate = ""
                        this.$message.warning("查询时间设置错误：超过当前时间！")
                        this.fntableParm.time_after = null
                    }else {
                        if(!(this.endDate == "" || this.endDate == null)){
                            const end = new Date(this.endDate)
                            if(start.getTime() > end.getTime()){
                                this.startDate = ""
                                this.$message.warning("查询时间设置错误：开始时间大于结束时间！")
                                this.fntableParm.time_after = null
                            }
                        }
                    }
                } else {
                    this.fntableParm.time_after = null
                } 
            },
            endTimeChange(val){
                if (val) {
                    const end = new Date(val)
                    const endStr = `${end.getFullYear()}-${(end.getMonth() + 1).toString().padStart(2, '0')}-${end.getDate().toString().padStart(2, '0')}`
                    this.fntableParm.time_before = endStr

                    const today = new Date()
                    const todayIntegralPoint = new Date(today.getFullYear(), today.getMonth(), today.getDate());

                    if(end.getTime() > todayIntegralPoint.getTime()){
                        this.endDate = ""
                        this.$message.warning("查询时间设置错误：超过当前时间！")
                        this.fntableParm.time_before = null
                    }else {
                        if(!(this.startDate == "" || this.startDate == null)){
                            const start = new Date(this.startDate)
                            if(start.getTime() > end.getTime()){
                                this.endDate = ""
                                this.$message.warning("查询时间设置错误：开始时间大于结束时间！")
                                this.fntableParm.time_before = null
                            }
                        }
                    }
                } else {
                    this.fntableParm.time_before = null
                } 
            },
          
            // 导出excel表格函数
            exportExcel(tableId,filename){
                
                const timestamp  = Date.now();
              
                const datenow = timestampToTime(timestamp)
               
                
                //timestampToTime
              
                let workbook  = XLSX.utils.table_to_book(document.querySelector("#" + tableId));
                let sheetName = workbook.SheetNames[0];
                let worksheet = workbook.Sheets[sheetName];
                const originalRange = XLSX.utils.decode_range(worksheet['!ref']);
                const totalColumns = originalRange.e.c + 1; // 原始总列数（列索引从0开始）
                const keepColumns = totalColumns - 1;
                // 删除最后一列的所有单元格
                Object.keys(worksheet).forEach(cellAddress => {
                if (cellAddress.startsWith('!')) return; // 跳过特殊属性
                const colIndex = XLSX.utils.decode_cell(cellAddress).c;
                if (colIndex === totalColumns - 1) delete worksheet[cellAddress];
                });

                // 调整工作表的范围
                const newRange = XLSX.utils.decode_range(worksheet['!ref']);
                newRange.e.c = keepColumns - 1; // 新的结束列索引
                worksheet['!ref'] = XLSX.utils.encode_range(newRange);
                XLSX.writeFile(workbook, filename + datenow + ".xlsx");
            },
            exportTable(){
             
                // 导出表格数据
                this.exportExcel('checkrecordtable', '巡检记录');
            }

            
    },
    created(){
        
     
        
        this.getData()
        // let loginInfo = {
        //     name:localStorage.getItem('userName'),
        //     password:localStorage.getItem('password')
        // }
        // login(loginInfo).then( res =>{
        //     console.log(res);
            
        // }).catch(error =>{
        //     console.log('error');
        // })

    }
 }


</script>
<style lang="scss" scoped>
.inspection-wrapper{
    // height: calc(100vh *0.8);
    background: url("@/assets/bigscreen/block_bg.jpg") no-repeat;
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    height: calc(100vh*0.85);
    .devicemanage_class_1{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  
    padding: 20px;
    height: 85%;
    .seachtitle{
        width: 100%;
        .tableform{
            padding: 0px;
        }
    }
    .ops_content{
        width: 100%;
        height: 90%;
        overflow: scroll;
        // overflow: scroll;
        // .el-table{
        //     height: 100%;
        // }
    }
   
    }
    // .pageset{
    //     height: 10%;
    // }
}


.rt-container{
        width: 100%;
        display: flex;
        justify-content: space-between;
    }
    .div_11{
        height: 100px;
        width: 20%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .div_111{
        justify-content: center;
    }
    .div_22{
        height: 100px;
        width: 3px;
    }
    .dev_11_backgroud_1_1{
        background: url("@/assets/bigscreen/线条.png") no-repeat;
        background-size: 100% 100%;
        background-position: center;
        background-repeat: no-repeat; 
    }
    .dev_11_backgroud_1{
        height: 100%;
        width: 50%;
        background: url("@/assets/bigscreen/devman1.png") no-repeat;
        background-size: 50% 60%;
        background-position: 50% 60%;
        background-repeat: no-repeat; 
    }
    .dev_11_backgroud_2{
        height: 100%;
        width: 50%;
        background: url("@/assets/bigscreen/devman2.png") no-repeat;
        background-size: 50% 60%;
        background-position: 50% 60%;
        background-repeat: no-repeat; 
    }
    .dev_11_backgroud_3{
        height: 100%;
        width: 50%;
        background: url("@/assets/bigscreen/devman3.png") no-repeat;
        background-size: 50% 60%;
        background-position: 50% 60%;
        background-repeat: no-repeat; 
    }
    .dev_11_backgroud_4{
        height: 100%;
        width: 50%;
        background: url("@/assets/bigscreen/devman4.png") no-repeat;
        background-size: 50% 60%;
        background-position: 50% 60%;
        background-repeat: no-repeat; 
    }
    .dev_11_backgroud_5{
        height: 100%;
        width: 50%;
        background: url("@/assets/bigscreen/devman5.png") no-repeat;
        background-size: 50% 60%;
        background-position: 50% 60%;
        background-repeat: no-repeat; 
    }

    .space-header{
      
        font-size: 17px;
        margin-top:4px ;
       
    }
    .space-header-title{
     
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
       
    }
    .space-main{
        // padding-top : 5%;
        width: 50%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
    }
    .space-main-up{
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-right: 20%;
    }
    .center-container_dev {
        display: flex;
        align-items:  flex-start;
        justify-content: center;
        padding-top: 12%;
    }
    .custom-button_dev {  
        background-image: url(@/assets/bigscreen/addDevButton.png);  
        background-size: cover; /* 根据需要调整背景图片的大小 */  
        border: none; /* 取消边框 */ 
    }  
    .devicemanage_class{
      background: url("@/assets/bigscreen/devicemanage_backgroud1.png") no-repeat;
      background-size: 100% 100%;
      background-position: center;
      background-repeat: no-repeat;
    }

    .devicemanage_class_1{
      background: url("@/assets/bigscreen/block_bg.jpg") no-repeat;
      background-size: 100% 100%;
      background-position: center;
      background-repeat: no-repeat;
    }

</style> 